"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItems = void 0;
const SocialShareButton_1 = __importDefault(require("./components/SocialShareButton"));
const social_share_widget_styles_1 = require("./social-share-widget-styles");
const social_share_widget_helpers_1 = require("./social-share-widget.helpers");
exports.ListItems = [
    {
        renderer: SocialShareButton_1.default,
        icon: social_share_widget_styles_1.FacebookIcon,
        label: "Facebook",
        style: { color: '#1C73E8', margin: 0 },
        onClick: social_share_widget_helpers_1.onFacebookClick,
    },
    {
        renderer: SocialShareButton_1.default,
        icon: social_share_widget_styles_1.LinkedinIcon,
        onClick: social_share_widget_helpers_1.onLinkedInClick,
        label: "LinkedIn",
        style: { color: '#1C73E8', margin: 0 }
    },
    {
        renderer: SocialShareButton_1.default,
        icon: social_share_widget_styles_1.TwitterIcon,
        label: "Twitter",
        onClick: social_share_widget_helpers_1.onTwitterClick,
        style: { color: '#1C73E8', margin: 0 }
    },
    {
        renderer: SocialShareButton_1.default,
        icon: social_share_widget_styles_1.WhatsApp,
        label: "Whatsapp",
        onClick: social_share_widget_helpers_1.onWhatsAppClick,
        style: { color: '#1C73E8', margin: 0 }
    },
];
//# sourceMappingURL=config.js.map